import React, { useEffect, useState, Suspense } from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { useTheme } from "@material-ui/styles";
import useStyles from "./styles";
import Header from "@features/Layout/Header";
import Sidebar from "@features/Layout/Sidebar";
import LayoutBottomNavigation from "@features/Layout/BottomNavigation";
import { CircularProgress } from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Footer from "@features/Layout/Footer";
import CustomContainer from "../../../components/Container";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { routes } from "@features/Layout/MainRouter";
import Layout from "./type";
import clsx from "clsx";
import { headerItems1, headerItems2 } from "../Header/menuItems";
import { useMediaQuery } from "@material-ui/core";
import LayoutContext from "@features/Layout/Core/LayoutContext";

const PageLayout = props => {
  const { children, width } = props;
  const classes = useStyles();
  const { promiseInProgress } = usePromiseTracker();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [state, setState] = useState({
    showHeader: false,
    showMenu: false,
    showFooter: false,
    layoutType: Layout.Central,
    backgroundColorWhite: false,
    menuOver: false,
    opanMenu: false,
    paddingLayout: false
  });
  const menuItems =
    state.layoutType === Layout.FullWidth ? headerItems2 : headerItems1;

  useEffect(() => {
    if (location) {
      const selectedRoute = routes.find(opt =>
        matchPath(history.location.pathname, {
          path: opt.path,
          exact: true
        })
      );

      if (selectedRoute) {
        setState(preveState => ({
          ...preveState,
          showHeader: selectedRoute.showHeader,
          showMenu: selectedRoute.showMenu,
          showFooter: selectedRoute.showFooter,
          layoutType: selectedRoute.layoutType,
          backgroundColorWhite: selectedRoute.backgroundColorWhite,
          menuOver: selectedRoute.menuOver,
          paddingLayout: selectedRoute.paddingLayout,
        }));
      }
    }
  }, [location]);

  const changeChilde = open => {
    setState(preveState => ({
      ...preveState,
      opanMenu: open
    }));
  };

  return (
    <LayoutContext.Provider value={{ isDesktop }}>
      <div className={classes.wrapper}>
        {state.showMenu && (
          <Sidebar
            changeChilde={changeChilde}
            menuItems={menuItems}
            menuOver={state.menuOver}
          />
        )}
        <main id="main" className={classes.content}>
          {state.showHeader && (
            <Header opanMenu={state.opanMenu} menuItems={menuItems} paddingLayout={state.paddingLayout} />
          )}
          <Suspense fallback={<></>}>
            <CustomContainer
              maxWidth={state.layoutType === Layout.FullWidth ? false : ""}
              classes={clsx(classes.pageContentWrapper, {
                opanMenu: state.opanMenu,
                fullWidth: state.layoutType === Layout.FullWidth,
                backgroundColorWhite: state.backgroundColorWhite,
                paddingLayout: state.paddingLayout,                
              })}
            >
              {children}
            </CustomContainer>

            {/*Only in before login apage*/}
            {state.showFooter && <Footer opanMenu={state.opanMenu} paddingLayout={state.paddingLayout}  />}
          </Suspense>
          {/* <LayoutBottomNavigation meuItems={menuItems} /> */}
        </main>
      </div>
    </LayoutContext.Provider>
  );
};

export default withWidth()(PageLayout);
// {/* <div className={classes.root} dir={theme.direction}>
// {state.showMenu ? (
//   <div className={classes.wrapper}>
//     <Sidebar menuItems={menuItems} />
//     <main className={classes.content}>
//       {state.showHeader && <Header menuItems={menuItems} />}
//       <CustomContainer
//         maxWidth={state.layoutType === Layout.FullWidth ? false : "lg"}
//         classes={clsx(classes.pageContentWrapper, {
//           fillWidth: state.layoutType === Layout.FullWidth,
//         })}
//       >
//         {children}
//       </CustomContainer>

//       {/*Only in before login apage*/}
//       {state.showFooter && <Footer />}

//       {/* <LayoutBottomNavigation meuItems={menuItems} /> */}
//     </main>
//   </div>
// ) : (
//   <main
//     className={clsx(classes.content, {
//       fillWidth: state.layoutType === Layout.FullWidth,
//     })}
//   >
//     {state.showHeader && <Header menuItems={menuItems} />} */}
